import React, { useState, useRef, useEffect } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

const CollapsiblePanel = ({ title, children, className = '', maxHeight = '230px', fill = false }) => {
  const [isOpen, setIsOpen] = useState(true);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState('auto');

  useEffect(() => {
    if (fill) return; // fill modunda yükseklik flexbox ile yönetilir, scrollHeight hesabına gerek yok
    if (isOpen) {
      const height = contentRef.current.scrollHeight;
      setContentHeight(`${height}px`);
    } else {
      setContentHeight('0px');
    }
  }, [isOpen, children, fill]);

  // fill modunda kök kapsayıcı bir flex öğesidir: açıkken boşalan alanı paylaşarak büyür,
  // kapalıyken sadece başlık şeridi kadar yer kaplar.
  const rootClass = fill
    ? `${isOpen ? 'flex min-h-0 flex-1 flex-col' : 'flex-none'} shadow-sm ${className}`
    : `mb-4 shadow-sm ${className}`;

  // Gövde: fill modunda açıkken kalan dikey alanı doldurur (iç içerik kendi içinde kayar),
  // kapalıyken yükseklik 0'a iner. fill kapalıyken eski maxHeight animasyonu korunur.
  const bodyClass = fill
    ? `app-panel-body overflow-hidden transition-all duration-300 ease-in-out ${
        isOpen ? 'flex min-h-0 flex-1 flex-col' : 'h-0'
      }`
    : 'app-panel-body transition-all duration-300 ease-in-out overflow-hidden';

  const bodyStyle = fill ? undefined : { maxHeight: contentHeight };

  // İç içerik: fill modunda büyüyen gövde içinde kayar; aksi halde sabit maxHeight cap'i.
  const innerClass = fill
    ? 'scrollbar-slim min-h-0 flex-1 overflow-y-auto p-4 pb-8'
    : 'scrollbar-slim overflow-y-auto p-4 pb-8';

  const innerStyle = fill ? undefined : { maxHeight };

  return (
    <div className={rootClass}>
      <button
        className="app-panel-header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-base">{title}</span>
        {isOpen ? (
          <ChevronUpIcon className="h-4 w-4" />
        ) : (
          <ChevronDownIcon className="h-4 w-4" />
        )}
      </button>
      <div className={bodyClass} style={bodyStyle}>
        <div ref={contentRef} className={innerClass} style={innerStyle}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsiblePanel;
